var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommandes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 163.5 137.4",
    style: {
      enableBackground: "new 0 0 163.5 137.4"
    },
    xmlSpace: "preserve",
    fill: "#0350a5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60.3,107.7c-1.3-0.3-2.7-0.6-4-1.1c-4.9-1.7-9.6-4.1-13.9-7.1C35.7,95,29.8,89.4,24.8,83c-6-7.8-10.9-16.3-13.6-25.9 c-1.1-3.5-1.5-7.1-1.4-10.7c0-3.6,1.6-7,4.3-9.4c2.3-2,4.5-4,6.9-5.8c3.7-2.7,7.5-2.4,10.6,1.1c3.3,3.6,6.4,7.4,9.4,11.3 c2.3,2.9,1.9,7.1-0.8,9.6c-1.9,1.8-4,3.5-6,5.2c-0.2,0.1-0.4,0.3-0.7,0.5c4.2,9.4,10.9,17.4,19.4,23.1l4.8-4.1 c1.2-1.2,2.7-2.1,4.2-2.6c2.6-0.9,5.4-0.1,7.2,1.9c3.4,3.9,6.7,7.8,9.9,11.9c2.2,2.9,2,7-0.6,9.5c-2.5,2.4-5.2,4.7-7.9,6.9 c-1.9,1.5-4.3,2.3-6.7,2.3c-0.2,0-0.3,0.1-0.5,0.1L60.3,107.7z M61.8,103.3c2.5,0.4,5-0.4,6.9-2c1.8-1.6,3.7-3.2,5.5-4.8 c0.2-0.2,0.5-0.4,0.7-0.6c1.3-1.1,1.5-3,0.4-4.3c0,0,0-0.1-0.1-0.1c-1.2-1.6-2.6-3.1-3.8-4.7c-1.7-2-3.3-4-5-6 c-1-1.3-2.9-1.6-4.2-0.6c0,0-0.1,0.1-0.1,0.1c-0.3,0.2-0.6,0.4-0.9,0.7c-1.9,1.6-3.8,3.2-5.8,4.8c-1.2,1.1-3,1.3-4.3,0.3 c-1-0.6-2.1-1.3-3.1-2c-4.4-3.2-8.2-7.1-11.5-11.4c-3-3.7-5.5-7.9-7.2-12.4c-0.9-2.4-0.5-3.5,1.5-5.2c2-1.6,4.1-3.3,6.1-5.1 c1.3-0.9,1.5-2.7,0.6-4c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.3-0.4-0.5-0.6-0.8l-8-9.6c-1.7-2-3.4-2.2-5.4-0.5c-2,1.7-3.9,3.2-5.8,4.9 c-0.9,0.8-1.7,1.7-2.3,2.8c-1,2.3-1.2,4.9-0.7,7.3c0.5,3.8,1.5,7.5,2.9,11c2.5,6.2,5.8,12.1,9.9,17.4c7,9.5,16.2,17.1,26.8,22.2 C56.6,102.1,59.2,102.9,61.8,103.3L61.8,103.3z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 128.5,
    cy: 33.2,
    rx: 4.7,
    ry: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 110,
    cy: 33.2,
    rx: 4.7,
    ry: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 90.7,
    cy: 33.1,
    rx: 4.7,
    ry: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133,10.2H86.7C80.8,10.2,76,15,76,20.9v23.3l-24.5,17H133c5.9,0,10.8-4.9,10.8-10.9V20.9 C143.8,15,138.9,10.2,133,10.2z M140.2,50.2c0,4-3.1,7.3-7.1,7.3H94.3h-7.6H62.9l16.5-11.5V20.9c0-3.8,3.3-7.1,7.3-7.1H133 c4,0,7.1,3.3,7.1,7.1V50.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommandes);
export default __webpack_public_path__ + "static/media/commandes.0fd8dbbe7e0f0bf2490d04aefa371c85.svg";
export { ForwardRef as ReactComponent };